import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './jobSiteList.scss';
import { companyService } from "../../services/apiService";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { JobSiteWithStats } from "../../store/interfaces";

const JobSiteListPage: React.FC = () => {
  const [jobSites, setJobSites] = React.useState<JobSiteWithStats[]>([]);
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    async function fetchData() {
      if (!user || !user.companyId) {
        return;
      }

      try {
        const data = await companyService.getCompanyJobSitesWithStats(user, user.companyId);
        // Sort job sites by employee count in descending order
        const sortedData = data.sort((a, b) => b.currentEmployeeCount - a.currentEmployeeCount);
        setJobSites(sortedData);
      } catch (error) {
        console.error('Get Company Job Sites error:', error);
      }
    }

    fetchData();
  }, [user]);

  return (
    <div className="jobSite-container">
      <h2>Job Sites</h2>
      <table className="jobSite-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Employee Count</th>
            <th>Current Cost Codes</th>
          </tr>
        </thead>
        <tbody>
          {jobSites.map((jobSite, index) => (
            <tr
              key={index}
              onClick={() => navigate(`/jobSites/${jobSite.id}`)}
              className="clickable-row"
            >
              <td>{jobSite.name}</td>
              <td>{jobSite.currentEmployeeCount}</td>
              <td>{jobSite.activeCostCodes.length > 0
                ? jobSite.activeCostCodes.map(code => code.name).join(', ')
                : 'No Cost Codes'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


export default JobSiteListPage;
